import type { AssociationType } from '@libs/associations';
import { getAssociatedModelIdsFromProduct } from '@libs/product.helper';
import type { ProductFragmentEnhanced } from '@models/enhanced-fragments';

export const getAssociatedModelIdsFromProducts = (
  products: ProductFragmentEnhanced[],
  associationType: AssociationType.ALTERNATIVE_PRODUCT | AssociationType.SUITABLE_PRODUCT | AssociationType.SHELVES
): string[] => {
  const productAssociatedModelIds = new Set<string>();
  products.forEach(value => {
    const modelIds = getAssociatedModelIdsFromProduct(value, associationType) ?? [];
    modelIds.forEach(modelId => productAssociatedModelIds.add(modelId));
  });
  return Array.from(productAssociatedModelIds.values());
};
